import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

export const UnsavedChangesDialog: React.FC<
  UnsavedChangesDialogProps
> = ({ open, onCancel, onDiscard }) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center">
          <Warning color="warning" />
          <Typography variant="h6">Unsaved changes</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You have unsaved changes. What would you like to do?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          If you discard, your changes will not be saved.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={onDiscard} variant="outlined" color="error">
          Discard
        </Button>
      </DialogActions>
    </Dialog>
  );
};